"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitSwitch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var context_1 = require("../../context/context");
var hooks_1 = require("../../hooks");
var styles_1 = require("../../styles");
var LimitSwitch = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, Component = _a.Component;
    var _c = (0, context_1.useTwapContext)(), state = _c.state, isLimitPanel = _c.isLimitPanel;
    var isMarketOrder = state.isMarketOrder;
    var onChange = hooks_1.stateActions.useOnLimitMarketSwitch();
    var onSelect = (0, react_1.useCallback)(function (value) {
        onChange(value);
    }, [onChange]);
    if (isLimitPanel)
        return null;
    if (Component) {
        return ((0, jsx_runtime_1.jsx)(Component, { onClick: onSelect, options: [
                { label: "Market", value: true },
                { label: "Limit", value: false },
            ], selected: !!isMarketOrder }));
    }
    return ((0, jsx_runtime_1.jsxs)(StyledLimitSwitch, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(StyledLimitSwitchButton, __assign({ className: "".concat(!!isMarketOrder ? "twap-limit-switch-selected" : ""), "$selected": !!isMarketOrder, onClick: function () { return onSelect(true); } }, { children: "Market" })), (0, jsx_runtime_1.jsx)(StyledLimitSwitchButton, __assign({ className: "".concat(!isMarketOrder ? "twap-limit-switch-selected" : ""), "$selected": !isMarketOrder, onClick: function () { return onSelect(false); } }, { children: "Limit" }))] })));
};
exports.LimitSwitch = LimitSwitch;
var StyledLimitSwitch = (0, styled_components_1.default)(styles_1.StyledRowFlex)({
    padding: 3,
    overflow: "hidden",
    width: "auto",
    borderRadius: 20,
});
var StyledLimitSwitchButton = (0, styled_components_1.default)("button")(function ($selected) {
    return {};
});
